export type HeaderNavLinkType = 'internal' | 'external' | 'category' | 'collection' | 'none';
export type HeaderNavMenuType = 'link' | 'dropdown' | 'mega';

export interface HeaderNavMegaColumn {
  title?: string;
  items?: HeaderNavItem[];
}

export interface HeaderNavMegaMenu {
  columns?: HeaderNavMegaColumn[];
  promoImage?: string;
  promoLink?: string;
  promoTitle?: string;
}

export interface HeaderNavItem {
  id: string;
  label: string;
  url?: string;
  linkType?: HeaderNavLinkType;
  categorySlug?: string;
  collectionSlug?: string;
  icon?: string;
  imageUrl?: string;
  thumbnailUrl?: string;
  badge?: string;
  badgeColor?: string;
  bgColor?: string;
  textColor?: string;
  hoverBgColor?: string;
  hoverTextColor?: string;
  openInNewTab?: boolean;
  isEnabled?: boolean;
  order: number;
  menuType?: HeaderNavMenuType;
  megaMenu?: HeaderNavMegaMenu;
  children?: HeaderNavItem[];
}

export const createEmptyNavItem = (partial?: Partial<HeaderNavItem>): HeaderNavItem => ({
  id: `nav-${Date.now()}-${Math.random().toString(36).slice(2, 7)}`,
  label: 'New Item',
  url: '/',
  linkType: 'internal',
  order: 1,
  isEnabled: true,
  menuType: 'link',
  openInNewTab: false,
  ...partial,
});
